import { render, staticRenderFns } from "./vico.vue?vue&type=template&id=3967887e&"
import script from "./vico.vue?vue&type=script&lang=js&"
export * from "./vico.vue?vue&type=script&lang=js&"
import style0 from "./vico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports